module.exports = __webpack_public_path__ + "img/img-classify7.09cc7aa2.png";